module.exports = __webpack_public_path__ + "b27656122ea5770f46472703823e58ca.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/infection_card.png
 ** module id = 1065
 ** module chunks = 0
 **/